import RichtextSectionWithBorder, { RichtextSectionWithBorderProps } from './RichtextSectionWithBorder'

export default RichtextSectionWithBorder

export { RichtextSectionWithBorderProps, RichtextSectionWithBorder }
